import { AppDispatch } from '@/store/index';
import { ToursSlice } from '@/store/reducers/ToursReducer';
import { ToursService } from '@services/ToursService';

export const ToursActionCreators = {
    fetchTours: () => async (dispatch: AppDispatch) => {
        dispatch(ToursSlice.actions.setLoading(true));
        try {
            const response = await ToursService.fetchPublished();
            dispatch(ToursSlice.actions.setTours(response.data));
        } finally {
            dispatch(ToursSlice.actions.setLoading(false));
        }
    },
    startTour: (tourId: string) => async (dispatch: AppDispatch) => {
        dispatch(ToursSlice.actions.startTour(tourId));
    },
    restoreTour: (tourId: string, stepIndex: number, stepHistory: number[]) => async (dispatch: AppDispatch) => {
        dispatch(ToursSlice.actions.restoreTour({ tourId, stepIndex, stepHistory }));
    },
    stopTour: () => async (dispatch: AppDispatch) => {
        dispatch(ToursSlice.actions.stopTour());
    },
    setStepIndex: (index: number) => async (dispatch: AppDispatch) => {
        dispatch(ToursSlice.actions.setStepIndex(index));
    },
    setStepHistory: (history: number[]) => async (dispatch: AppDispatch) => {
        dispatch(ToursSlice.actions.setStepHistory(history));
    },
    pushStepHistory: (index: number) => async (dispatch: AppDispatch) => {
        dispatch(ToursSlice.actions.pushStepHistory(index));
    },
    popStepHistory: () => async (dispatch: AppDispatch) => {
        dispatch(ToursSlice.actions.popStepHistory());
    },
    completeTour: (tourId: string) => async (dispatch: AppDispatch) => {
        dispatch(ToursSlice.actions.markTourCompleted(tourId));
        ToursService.updateProgress({ tourId, status: 'completed', lastStepIndex: 0 });
    },
    skipTour: (tourId: string) => async (dispatch: AppDispatch) => {
        dispatch(ToursSlice.actions.markTourSkipped(tourId));
        ToursService.updateProgress({ tourId, status: 'skipped', lastStepIndex: 0 });
    },
    updateProgress:
        (tourId: string, status: string, lastStepIndex: number) =>
        async (_dispatch: AppDispatch) => {
            ToursService.updateProgress({ tourId, status, lastStepIndex });
        },
    resetTourProgress: (tourId: string) => async (dispatch: AppDispatch) => {
        await ToursService.resetProgress(tourId);
        dispatch(ToursSlice.actions.setLoading(true));
        try {
            const response = await ToursService.fetchPublished();
            dispatch(ToursSlice.actions.setTours(response.data));
        } finally {
            dispatch(ToursSlice.actions.setLoading(false));
        }
    },
};
